module.exports = __webpack_public_path__ + "static/media/view category.1b7c1878.svg";